/* MiMiKo — Read More toggle for product description */
(function () {
  function initReadMore() {
    var descBlocks = document.querySelectorAll('.product__description');
    descBlocks.forEach(function (desc) {
      /* Skip if already wrapped */
      if (desc.parentNode.classList.contains('mimiko-desc-wrapper')) return;

      /* Only add Read More if content is tall enough to warrant it */
      if (desc.scrollHeight <= 90) return;

      /* Wrap */
      var wrapper = document.createElement('div');
      wrapper.className = 'mimiko-desc-wrapper';
      desc.parentNode.insertBefore(wrapper, desc);

      var inner = document.createElement('div');
      inner.className = 'mimiko-desc-inner';
      inner.appendChild(desc);
      wrapper.appendChild(inner);

      var fade = document.createElement('div');
      fade.className = 'mimiko-desc-fade';
      wrapper.appendChild(fade);

      var btn = document.createElement('button');
      btn.className = 'mimiko-read-more-btn';
      btn.textContent = 'Read more';
      wrapper.appendChild(btn);

      btn.addEventListener('click', function () {
        var expanded = inner.classList.toggle('is-expanded');
        btn.textContent = expanded ? 'Read less' : 'Read more';
      });
    });
  }

  /* Run on DOMContentLoaded and also after Shopify variant changes re-render */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReadMore);
  } else {
    initReadMore();
  }
  /* Re-run if Shopify re-renders product info via AJAX */
  document.addEventListener('variant:change', function () {
    setTimeout(initReadMore, 100);
  });
})();
